import React from 'react';
import auth from '../services/auth';
import styles from './Home.module.css';
import logo from '../assets/logo.png';

function Home() {
  const login = async () => {
    await auth.authorize();
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <p className={styles.logoText + ' ft-28'}><img src={logo} className={styles.logo} alt="logo" /> TARS</p>
        <div className={styles.welcomeText + ' ft-20'}>Welcome</div>
        <p className={styles.subText + ' ft-14'}>to Livspace Production Management Console</p>
        <button className={styles.primaryButton} type="button" onClick={login}>Please Login</button>
      </div>
    </div>
  );
}

export default Home;
